import React from "react";
import { withRouter } from "react-router-dom";
import { isAuthenticated } from "../store/selectors/AuthSelectors";
import { connect } from "react-redux";
import { QueryClientProvider, QueryClient } from "react-query";
import Header from "../Header/Header";
import UpdateData from "./updateData";
const queryClient = new QueryClient();


const UpdateLiveTradeVisibility = () => {
  return (
    <QueryClientProvider client={queryClient}>
      <Header />
        <div
          className={`bg-gradient-to-b from-[#000000]/5 to-[#000000] flex flex-col xl:min-h-screen w-full lg:items-center justify-center px-3 lg:px-0`}
        >
          <UpdateData />
        </div>
    </QueryClientProvider>
  );
};

const mapStateToProps = (state) => {
  return {
    isAuthenticated: isAuthenticated(state),
  };
};

export default withRouter(connect(mapStateToProps)(UpdateLiveTradeVisibility));
